import React from 'react';
import BroadcastFrontDeskList from './components/BroadcastFrontDeskList';

const CalendarFrontDesk = () => (
  <React.Suspense fallback={<div>Loading...</div>}>
    <BroadcastFrontDeskList />
  </React.Suspense>
);

export default CalendarFrontDesk;
